module.exports = __webpack_public_path__ + "img/68.7.Chla.20b24c4f.png";